import $ from 'jquery';
let tpl = require('./loading.tpl.html');

class LoadingController {
    constructor($equalOneUIService, $scope, $timeout) {
        this.$equalOneUIService = $equalOneUIService;
        this.$timeout = $timeout;
        this.enabled = $equalOneUIService.enabled;
        this.lastCollapseChange=0;

        /**
         * Bootstrap has a limitation with collapse: 'hide' or 'show' is ignore if a transition is already ongoing.
         * To overcome the situation, the call is delayed by 500ms minimum after the last transition start.
         * As bootstrap implementation for collapse defines a transition duration of 350 ms, this is enough to prevent overlaps.
         */
        $scope.$watch(() => {this.enabled.loading}, (newValue, oldValue) => {
            if (newValue) {
                let current = (new Date()).getTime();
                let nextExec = ((current - this.lastCollapseChange)<500 ? this.lastCollapseChange+500 : current);
                let delta =  nextExec - current;
                this.lastCollapseChange = nextExec;
                this.$timeout(() => {
                    $('#collapseloading').collapse('show');
                }, delta);
            }
            else {
                let current = (new Date()).getTime();
                let nextExec = ((current - this.lastCollapseChange)<500 ? this.lastCollapseChange+500 : current);
                let delta =  nextExec - current;
                this.lastCollapseChange = nextExec;
                this.$timeout(() => {
                    $('#collapseloading').collapse('hide');
                }, delta);
            }
        }, true);
    }
}

LoadingController.$inject = ['EQualOneUIService', '$scope', '$timeout'];

let Loading = {
    bindings: {},
    templateUrl: tpl,
    controller: LoadingController
};

export default Loading;


// WEBPACK FOOTER //
// ./src/equalone-ui/components/loading/loading.component.js